
import helpers from "../../../_helpers/helpersFunction";


export default {
    checkTransactionStatus
}





/* ------- controlla il pagamento per il flusso S2S di TrustPay dopo il redirect con 3DS */
async function checkTransactionStatus(dati){
    return await fetch(process.env.REACT_APP_PAY+"/orders/mollie/checkTransactionStatus",{ 
      method: 'post', 
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(dati)
    })
    .then(res => res.json())
    .then(response => {
      return response
    })
    .catch((err)=>{
        helpers.logToBackend("Mollie Error 1",{clickid:dati.clickid,error:err.message})
    })
  }

